// Types of sections in the slide
export const SLIDING_IMAGE_DECK = 'SLIDING_IMAGE_DECK';
export const IMAGE_CARD_DECK = 'IMAGE_CARD_DECK';
export const FEATURED_DECK = 'FEATURED_DECK';
export const SINGLE_CARD_SLIDER = 'SINGLE_CARD_SLIDER';
export const SUBSCRIBE = 'SUBSCRIBE'; 
export const FOOTER = 'FOOTER';
